import React, { useState } from "react";
import { loginUser } from "./api";

export default function Login({ onLogin, theme, toggleTheme }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!email || !password) {
            setError("Zəhmət olmasa E-poçt və Şifrəni daxil edin.");
            return;
        }

        setLoading(true);
        try {
            const res = await loginUser(email, password);
            // ERP cavab strukturu: { messages, data: { user, access_token, ... }, status }
            const payload = res.data?.data || res.data;
            const token = payload?.access_token || payload?.token;
            if (token) {
                onLogin({ user: payload.user, token });
            } else {
                setError("Token alına bilmədi.");
            }
        } catch (err) {
            setError(err.response?.data?.messages || err.response?.data?.detail || "Sistemə giriş zamanı xəta baş verdi.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: "100vh", display: "flex", flexDirection: "column",
            justifyContent: "center", alignItems: "center",
            backgroundColor: "var(--bg-main)", transition: "background-color 0.3s ease",
            position: "relative", overflow: "hidden"
        }}>
            {/* Background design flair */}
            <div style={{
                position: "absolute", top: "-10%", left: "-10%", width: "40%", height: "40%",
                background: "var(--primary-color)", filter: "blur(150px)", opacity: 0.15, zIndex: 0, borderRadius: "50%"
            }}></div>
            <div style={{
                position: "absolute", bottom: "-10%", right: "-10%", width: "30%", height: "30%",
                background: "var(--success-text)", filter: "blur(150px)", opacity: 0.1, zIndex: 0, borderRadius: "50%"
            }}></div>

            {/* Theme Toggle at top right */}
            <div style={{ position: "absolute", top: "24px", right: "32px", zIndex: 10 }}>
                <div
                    onClick={toggleTheme}
                    style={{
                        width: "58px", height: "30px", borderRadius: "20px",
                        backgroundColor: theme === "dark" ? "var(--primary-color)" : "#e2e8f0",
                        position: "relative", cursor: "pointer", display: "flex", alignItems: "center",
                        padding: "0 4px", justifyContent: "space-between",
                        transition: "background-color 0.4s ease",
                        boxShadow: theme === "dark" ? "inset 0 2px 4px rgba(0,0,0,0.3)" : "inset 0 2px 4px rgba(0,0,0,0.05)"
                    }}
                >
                    <span style={{ fontSize: "14px", zIndex: 1, paddingLeft: "3px", textShadow: "0 1px 2px rgba(0,0,0,0.1)", filter: theme === "dark" ? "grayscale(100%) opacity(0.3)" : "none", transition: "all 0.4s ease" }}>☀️</span>
                    <div style={{
                        position: "absolute", width: "24px", height: "24px",
                        backgroundColor: "#fff", borderRadius: "50%",
                        left: theme === "dark" ? "30px" : "4px",
                        transition: "left 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                        zIndex: 2
                    }} />
                    <span style={{ fontSize: "12px", zIndex: 1, paddingRight: "5px", filter: theme === "dark" ? "none" : "grayscale(100%) opacity(0.3)", transition: "all 0.4s ease" }}>🌙</span>
                </div>
            </div>

            <div className="animate-slide-down" style={{
                width: "420px", padding: "40px", backgroundColor: "var(--bg-card)",
                borderRadius: "20px", boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                border: "1px solid var(--border-color)", zIndex: 1, backdropFilter: "blur(10px)"
            }}>
                <div style={{ textAlign: "center", marginBottom: "32px" }}>
                    <div style={{ fontSize: "42px", marginBottom: "16px", filter: "drop-shadow(0px 4px 6px rgba(0,0,0,0.1))" }}>🔄</div>
                    <h2 style={{ fontSize: "24px", fontWeight: "800", color: "var(--text-main)", marginBottom: "8px", letterSpacing: "-0.5px" }}>Rotation Platform</h2>
                    <p style={{ fontSize: "14px", color: "var(--text-muted)", fontWeight: "500" }}>Modula daxil olmaq üçün məlumatlarınızı qeyd edin.</p>
                </div>

                {error && (
                    <div style={{
                        backgroundColor: "var(--danger-bg)", color: "var(--danger-text)",
                        padding: "12px 16px", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
                        marginBottom: "20px", border: "1px solid var(--danger-border)",
                        display: "flex", alignItems: "center", gap: "8px"
                    }}>
                        <span style={{ fontSize: "16px" }}>⚠️</span> {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <div>
                        <label style={{ display: "block", fontSize: "13px", color: "var(--text-main)", fontWeight: "600", marginBottom: "8px" }}>Elektron Poçt</label>
                        <input
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@example.com"
                            style={{
                                width: "100%", padding: "14px 16px", borderRadius: "10px",
                                border: "1px solid var(--border-color)", backgroundColor: "var(--bg-main)",
                                color: "var(--text-main)", fontSize: "14px", outline: "none",
                                transition: "all 0.3s ease",
                                boxShadow: "inset 0 2px 4px rgba(0,0,0,0.02)"
                            }}
                            className="login-input-wow"
                            autoComplete="off"
                        />
                    </div>
                    <div>
                        <label style={{ display: "block", fontSize: "13px", color: "var(--text-main)", fontWeight: "600", marginBottom: "8px" }}>Şifrə</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            style={{
                                width: "100%", padding: "14px 16px", borderRadius: "10px",
                                border: "1px solid var(--border-color)", backgroundColor: "var(--bg-main)",
                                color: "var(--text-main)", fontSize: "14px", outline: "none",
                                transition: "all 0.3s ease",
                                boxShadow: "inset 0 2px 4px rgba(0,0,0,0.02)",
                                letterSpacing: password ? "2px" : "normal"
                            }}
                            className="login-input-wow"
                            autoComplete="off"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            marginTop: "10px", width: "100%", padding: "14px", borderRadius: "10px",
                            backgroundColor: "var(--primary-color)", color: "#fff", border: "none",
                            fontSize: "15px", fontWeight: "700", cursor: loading ? "wait" : "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            display: "flex", justifyContent: "center", alignItems: "center", gap: "8px",
                            opacity: loading ? 0.7 : 1,
                            boxShadow: "0 8px 20px -6px rgba(37,99,235,0.5)"
                        }}
                        className="login-btn-wow"
                    >
                        {loading ? "Gözləyin..." : "Sistemə Giriş"}
                    </button>
                </form>
            </div>

            <style jsx="true">{`
                .login-input-wow:focus {
                    border-color: var(--primary-color) !important;
                    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.15) !important;
                    transform: translateY(-1px);
                }
                .login-btn-wow:hover {
                    box-shadow: 0 12px 25px -8px rgba(37,99,235,0.7) !important;
                    transform: translateY(-2px);
                }
                .login-btn-wow:active {
                    transform: translateY(0);
                }
            `}</style>
        </div>
    );
}
